var map = {
	"./Accountlist.vue": [
		5244,
		244
	],
	"./Accountpublish.vue": [
		3263,
		263
	],
	"./Areacategory.vue": [
		5793,
		793
	],
	"./CashOut.vue": [
		8664,
		664
	],
	"./Commission.vue": [
		3630,
		630
	],
	"./CreateStaff.vue": [
		2446,
		446
	],
	"./CustomerContract.vue": [
		309,
		309
	],
	"./CustomerList.vue": [
		4139,
		139
	],
	"./Delivery.vue": [
		7971,
		971
	],
	"./Editpass.vue": [
		194,
		194
	],
	"./ExpressSet.vue": [
		7462,
		462
	],
	"./GoodsCategory.vue": [
		855,
		855
	],
	"./GoodsParamset.vue": [
		1499,
		499
	],
	"./GoodsPublish.vue": [
		810,
		810
	],
	"./GoodsSpecset.vue": [
		6485,
		485
	],
	"./Goodslist.vue": [
		3277,
		306
	],
	"./Home.vue": [
		7406,
		406
	],
	"./MemberList.vue": [
		843,
		843
	],
	"./MerchantAccount.vue": [
		650,
		650
	],
	"./MerchantList.vue": [
		8953,
		953
	],
	"./MerchantShops.vue": [
		1955,
		955
	],
	"./Myinfo.vue": [
		7224,
		224
	],
	"./OrderList.vue": [
		7128,
		128
	],
	"./OrderList2.vue": [
		1944,
		944
	],
	"./OrderReport.vue": [
		4198,
		198
	],
	"./Recharge.vue": [
		1413,
		413
	],
	"./Rights.vue": [
		6139,
		520
	],
	"./Role.vue": [
		2826,
		826
	],
	"./Shopconfig.vue": [
		8013,
		13
	],
	"./SkuSetup.vue": [
		593,
		593
	],
	"./StaffList.vue": [
		1681,
		681
	],
	"./StaffRole.vue": [
		3422,
		422
	],
	"./Supplier.vue": [
		2144,
		144
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5627;
module.exports = webpackAsyncContext;